// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__3WA-K","selects":"Documents_selects__24nIp"};